import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { FirebaseDocRefType } from 'firebase'
import { fetchStoreDeliveryBreads } from 'repos/storeDeliveryBread'

const useFetchStoreDeliveryBreads = (): StoreDeliveryBreadType[] => {
  const storeRef: FirebaseDocRefType = useSelector((state: State) => getStoreRef(state))
  const [storeDeliveryBreads, setStoreDeliveryBreads] = useState<StoreDeliveryBreadType[]>([])

  useEffect(() => {
    ;(async () => {
      if (!storeRef) return
      const result = await fetchStoreDeliveryBreads(storeRef)
      setStoreDeliveryBreads([...result])
    })()
  }, [storeRef])

  return storeDeliveryBreads
}

export default useFetchStoreDeliveryBreads
